<template>
<div>
    <Breadcrumbs main="Admin" submain="Dashboard" title="Analytics" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                    <div class="grid-container mt-sm-0">
                        <div class="grid-item">
                            <span>Date From</span>
                            <div class="form-group">
                                <input type="date" class="form-control" v-model="date_from" style="width: 220px;">
                            </div>
                        </div>
                    </div>
                    <div class="grid-container mt-sm-0">
                        <div class="grid-item">
                            <span>Date To</span>
                            <div class="form-group">
                                <input type="date" class="form-control" v-model="date_to" style="width: 220px;">
                            </div>
                        </div>
                    </div>
                    
                    <div style="margin-top: 20px; display: flex; align-items: center; text-align: center; justify-content: center; color: white; background-color: #262062; padding: 2px 14px; width: 100px; border-radius: 5px; cursor: pointer; height: 39px;" @click="filterData()">
                        <h7>Filter</h7>
                    </div>
                    <div v-if="filterShow" style="margin-top: 20px; display: flex; align-items: center; text-align: center; justify-content: center; color: white; background-color: #DC3545; padding: 2px 14px; width: 100px; border-radius: 5px; cursor: pointer; height: 39px;" @click="resetFilters()">
                        <h7>Reset</h7>
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h5>Feature Frequency</h5>
                    </div>
                    <div class="card-body" v-if="!featureFrequencyLoading && !featureFrequencyError">
                        <div id="basic-bar">
                            <apexchart height="350" type="bar" :options="featurebarchart.chartOptions" :series="featurebarchart.series"></apexchart>
                        </div>
                    </div>
                    <div v-else>
                        <loader />
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h5>Activity Frequency</h5>
                    </div>
                    <div class="card-body" v-if="!activityFrequencyLoading && !activityFrequencyError">
                        <div id="basic-bar">
                            <apexchart height="650" type="bar" :options="activitybarchart.chartOptions" :series="activitybarchart.series"></apexchart>
                        </div>
                    </div>
                    <div v-else>
                        <loader />
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h5>User Type</h5>
                    </div>
                    <div class="card-body" v-if="!userTypeGraphLoading && !userTypeGraphError">
                        <div class="chart-overflow" id="bar-chart1"></div>
                        <GChart class="chart-overflow" id="bar-chart1" type="ColumnChart" :data="userTypeChart.chartData" :options="userTypeChart.options" />
                    </div>
                    <div v-else>
                        <loader />
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div v-if="!loading && !error">
                            <div class="d-flex flex-column flex-md-row">
                                <div class="col-md-4">
                                    <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                        <div class="title">Total Payments
                                        </div>
                                        <div class="count">{{ count_list?.total_payments }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import loader from '../loader/loader.vue';
import {
    GChart
} from 'vue-google-charts';

var primary = localStorage.getItem('primary_color') || '#7366ff';
var secondary = localStorage.getItem('secondary_color') || '#f73164';

export default {
    components: {
        loader,
        GChart
    },

    data() {
        return {
            date_from: null,
            date_to: null,
            filterShow: false
        }
    },

    computed: {
        ...mapState({
            count_list: state => state.dashboard.dashboard_count,
            loading: state => state.dashboard.dashboardCountLoading,
            error: state => state.dashboard.dashboardCountError,
            feature_frequency: state => state.dashboard.feature_frequency,
            featureFrequencyLoading: state => state.dashboard.featureFrequencyLoading,
            featureFrequencyError: state => state.dashboard.featureFrequencyError,
            activity_frequency: state => state.dashboard.activity_frequency,
            activityFrequencyLoading: state => state.dashboard.activityFrequencyLoading,
            activityFrequencyError: state => state.dashboard.activityFrequencyError,
            user_type: state => state.dashboard.user_type_graph,
            userTypeGraphLoading: state => state.dashboard.userTypeGraphLoading,
            userTypeGraphError: state => state.dashboard.userTypeGraphError,
        }),

        featurebarchart() {
            const featureFrequency = this.feature_frequency;

            return {
                series: [{
                    data: featureFrequency.data
                }],
                chartOptions: {
                    chart: {
                        type: 'bar',
                        height: 350
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: true
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    colors: [primary],
                    xaxis: {
                        categories: featureFrequency.labels
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                toolbar: {
                                    show: false,
                                }
                            }
                        }
                    }]
                }
            };
        },

        activitybarchart() {
            const activityFrequency = this.activity_frequency;

            return {
                series: [{
                    data: activityFrequency.data
                }],
                chartOptions: {
                    chart: {
                        type: 'bar',
                        height: 350
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: true
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    colors: [primary],
                    xaxis: {
                        categories: activityFrequency.labels
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                toolbar: {
                                    show: false,
                                }
                            }
                        }
                    }]
                }
            };
        },

        userTypeChart() {
            const experienceOptions = [{
                    label: 'Not Identified',
                    color: '#ff5c5c'
                },
                {
                    label: 'Student',
                    color: primary
                },
                {
                    label: 'Fresh Graduate',
                    color: secondary
                },
                {
                    label: 'Early Professional',
                    color: '#22af47'
                },
                {
                    label: 'Experienced Professional',
                    color: '#007bff'
                },
            ];

            const header = [
                ['Element', 'Density', {
                    role: 'style'
                }]
            ];

            const rows = this.user_type.labels.map((labelIndex, i) => [
                experienceOptions[labelIndex].label,
                this.user_type.data[i],
                experienceOptions[labelIndex].color
            ]);

            return {
                chartData: [...header, ...rows],
                options: {
                    width: '100%',
                    height: 500,
                    bar: {
                        groupWidth: '25%'
                    },
                    legend: {
                        position: 'none'
                    }
                }
            };
        }
    },

    mounted() {
        this.$store.dispatch("dashboard/fetchDashboardCount")
        this.$store.dispatch("dashboard/fetchFeatureFrequency", {
                date_from: this.date_from,
                date_to: this.date_to,
            })
        this.$store.dispatch("dashboard/fetchActivityFrequency", {
                date_from: this.date_from,
                date_to: this.date_to,
            })
        this.$store.dispatch("dashboard/fetchUserTypeGraph", {
                date_from: this.date_from,
                date_to: this.date_to,
            })
    },

    methods: {
        resetFilters() {
            this.filterShow = false;
            this.date_from = null;
            this.date_to = null;

            this.$store.dispatch("dashboard/fetchFeatureFrequency", {
                date_from: this.date_from,
                date_to: this.date_to,
            })
            this.$store.dispatch("dashboard/fetchActivityFrequency", {
                date_from: this.date_from,
                date_to: this.date_to,
            })
            this.$store.dispatch("dashboard/fetchUserTypeGraph" , {
                date_from: this.date_from,
                date_to: this.date_to,
            })
        },

        filterData() {
            this.filterShow = true;
            this.$store.dispatch("dashboard/fetchFeatureFrequency", {
                date_from: this.date_from,
                date_to: this.date_to,
            })
            this.$store.dispatch("dashboard/fetchActivityFrequency", {
                date_from: this.date_from,
                date_to: this.date_to,
            })
            this.$store.dispatch("dashboard/fetchUserTypeGraph", {
                date_from: this.date_from,
                date_to: this.date_to,
            })
        }
    }
};
</script>

<style scoped>
.margin-y-axis {
    margin-top: 16px;
    margin-bottom: 16px;
}

.margin-botton {
    margin-bottom: 16px;
}

.border-class {
    border-radius: 0.375rem;
}

.title {
    font-size: large;
    font-weight: 500;
    color: #fc9d3f;
}

.count {
    text-align: end;
    font-size: xx-large;
    font-weight: 500;
    padding-right: 28px;
}

.main-title {
    font-size: x-large;
    font-weight: 500;
}

@media (max-width: 1480px) {
    .main-title {
        font-size: large;
        font-weight: 500;
    }
}

@media (max-width: 768px) {
    .count {
        padding-right: 12px;
    }
}

@media (min-width: 768px) {
    .margin-y-axis {
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .margin-botton {
        margin-bottom: 0px;
    }
}
</style>
